import { Colors } from "../../../theme";
import { LifecycleName } from "../../../auth/roles";

export enum Progress {
  Completed = "completed",
  InProgress = "in progress",
  NotStarted = "not started"
}

export type DepartmentStatus = "not-started" | "in-progress" | "completed";

export type Department = {
  key: LifecycleName;
  label: string;
  status: DepartmentStatus;
};

// Case-insensitive like the overview grids' normalizeProgress: some stored entities carry
// "In Progress" rather than "in progress", and a strict match drew those as not started while
// the grid showed them in progress.
export const getStatus = (
  progress: string | null | undefined
): DepartmentStatus => {
  const normalized = progress?.toLowerCase();
  if (normalized === Progress.Completed) {
    return "completed";
  }
  if (normalized === Progress.InProgress) {
    return "in-progress";
  }
  return "not-started";
};

export const getCircleColor = (status: DepartmentStatus) => {
  switch (status) {
    case "completed":
      return Colors.NICE_GREEN;
    case "in-progress":
      return "#529CCF";
    case "not-started":
    default:
      return "#C6C6C6";
  }
};

export const getConnectorColor = (
  currentIndex: number,
  departments: Department[]
) => {
  const currentStatus = departments[currentIndex].status;

  if (currentStatus === "completed") {
    return Colors.NICE_GREEN;
  }
  return "#BDBDBD";
};
